const ChatHeader = () => (
    <div className="chat-header">
        Azania
    </div>
);

export default ChatHeader;
